import Header from './components/Header';
import Hero from './components/Hero';
import SectionApp from './components/SectionApp';
import SectionMedia from './components/SectionMedia';
import SectionCards from './components/SectionCards';
import SectionRanking from './components/SectionRanking';
import SectionComments from './components/SectionComments';
import SectionTopics from './components/SectionTopics';
import SectionContact from './components/SectionContact';
import SectionFaq from './components/SectionFaq';
import SectionFeatures from './components/SectionFeatures';
import SectionAbout from './components/SectionAbout';
import SectionIndex from './components/SectionIndex';
import SectionCarousel from './components/SectionCarousel';
import SectionUpdates from './components/SectionUpdates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionApp />
        <SectionMedia />
        <SectionCards />
        <SectionRanking />
        <SectionComments />
        <SectionTopics />
        <SectionContact />
        <SectionFaq />
        <SectionFeatures />
        <SectionAbout />
        <SectionIndex />
        <SectionCarousel />
        <SectionUpdates />
      </main>
      <Footer />
    </>
  );
}